import KlarnaPaymentCheckout from './KlarnaPaymentCheckout';

export default KlarnaPaymentCheckout;
